<script setup lang="ts">
import { RouterLink } from 'vue-router';
import IssueMobileCard from './IssueMobileCard.vue';
import type { IssueListItemDto } from '@/stores/issues';

interface Props {
  issues: IssueListItemDto[];
}
defineProps<Props>();
</script>

<template>
  <div class="flex flex-col gap-3" data-testid="issue-card-list">
    <RouterLink
      v-for="issue in issues"
      :key="issue.id"
      :to="`/issues/${issue.id}`"
      class="block no-underline"
    >
      <IssueMobileCard :issue="issue" />
    </RouterLink>
    <p v-if="issues.length === 0" class="text-body text-muted text-center py-12">
      No issues match the current filters.
    </p>
  </div>
</template>
